export default __webpack_public_path__ + "static/media/walletSm.70ead6b4.svg";